import React from 'react'
import ScrollToTop from '../../../const'
import Header from './Header'
import Footer from './Footer'

const Layout = ({ children }) => {
  return (
    <>
      <ScrollToTop />
      <Header />
      {children}
      <Footer />
    </>
  )
}

export default Layout